import { NormalizedData } from '../common/NormalizedData';
import { catalogIconUrl, CatalogItem } from './CatalogItem';
import { CatalogItemKey } from './CatalogItemKey';

export interface CatalogItemWithKey {
  key: CatalogItemKey;
  data: CatalogItem;
}

export function createListByKeys(keys: CatalogItemKey[], data: NormalizedData<CatalogItem>) {
  const results: CatalogItemWithKey[] = [];
  for (const key of keys) {
    const item = data.byId[key.unique_id];
    if (item) {
      results.push({ key, data: item });
    }
  }
  return results;
}

export function createDefaultList(data: NormalizedData<CatalogItem>): CatalogItemWithKey[] {
  const { byId, allIds } = data;
  return allIds.map(id => convertToDefault(byId[id]));
}

export function convertToDefault(item: CatalogItem): CatalogItemWithKey {
  switch (item.type) {
    case 'body-variable': {
      if (!item.rebody_pattern || item.rebody_pattern.length === 0) {
        return { key: { unique_id: item.unique_id }, data: item };
      }
      const pt = item.rebody_pattern[0];
      const key = { unique_id: item.unique_id, rebody_index: pt.index };
      return { key, data: item };
    }
    case 'color-variable': {
      const vr = item.variations[0];
      const key = { unique_id: vr.unique_id };
      return { key, data: item };
    }
    case 'normal':
    default: {
      const key = { unique_id: item.unique_id };
      return { key, data: item };
    }
  }
}

export function getIconUrl(key: CatalogItemKey, item: CatalogItem): string {
  let icon: string | undefined;
  switch (item.type) {
    case 'normal':
      icon = item.icon;
      break;
    case 'body-variable': {
      const found =
        item.rebody_pattern && item.rebody_pattern.find(pt => pt.index === key.rebody_index);
      icon = found?.icon;
      break;
    }
    case 'color-variable': {
      const found = item.variations.find(vr => vr.unique_id === key.unique_id);
      icon = found?.icon;
      break;
    }
    default:
      icon = undefined;
  }
  if (!icon) {
    return '';
  }
  return catalogIconUrl(icon);
}
